$(document).ready(function () {
    "use strict";
    if($(window).width()<992 && $('body').hasClass('sidebar-collapsed')){
        $('body').removeClass('sidebar-collapsed');
    }
    $('.nav-parent>a').click(function () {
        var parent = $(this).parent(), sub = parent.find('>ul');
        if (!$('body').hasClass('sidebar-collapsed')) {
            if (sub.is(':visible')) {
                sub.slideUp(300, function () {
                    parent.removeClass('nav-active');
                    /*
                    adjustMainContentHeight();
                    */
                });
            } else {
                visibleSubMenuClose();
                sub.slideDown(300, function () {
                    parent.addClass('nav-active');
                    /*
                    adjustMainContentHeight();
                    */
                });
            }
        }
        return false;
    });

    $('.side-navigation>li').hover(function () {
        $(this).addClass('nav-hover');
    }, function () {
        $(this).removeClass('nav-hover');
    });

    var selectedMenu = getUrlParameter(encodeURI('m'));
    if (selectedMenu !== false) {
        $('#' + selectedMenu).addClass('nav-active').siblings('.nav-active').removeClass('nav-active');
    }

    $('.search-content').clone().appendTo('.sidebar-left-info .search-field');

    $('.siteSelect').each(function () {
        if ($(this).find('option').length > 1) {
            $(this).addClass('select2').select2({
                dropdownCssClass: 'menu-search'
            }).on('select2:select', function (e) {
                if ($(e.currentTarget).val().length) {
                    var data = {siteID: $(e.currentTarget).val()};
                    $.ajax({
                        url: routeChangeSite,
                        type: 'POST',
                        dataType: 'json',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        data: data,
                        success: function (response) {
                            if (response['result'] === true) {
                                setTimeout(function () {
                                    window.location.href = routeAdmin;
                                }, 0.5);
                            }
                        }
                    });
                }
            });
        } else {
            $(this).attr('disabled', true);
        }
    });

    // $('select.form-control').each(function () {
    //     if ($(this).find('option').length > 10) {
    //         $(this).addClass('select2').select2();
    //     }
    // });

    $(document).on('change', '#SelectAllVariation', function () {
        if ($(this).is(':checked')) {
            $(document).find('.SelectVariation').prop('checked', true);
        } else {
            $(document).find('.SelectVariation').prop('checked', false);
        }
    });

    $(document).on('change','#Tumu', function () {
        if ($(this).is(':checked')) {
            $('.Sec').prop('checked', true);
        } else {
            $('.Sec').prop('checked', false);
        }
    });

    $(document).on('change','.Sec', function () {
        var tumu = $('#Tumu');
        if (tumu.is(':checked') && !$(this).is(':checked')) {
            tumu.prop('checked', false);
        }
    });

    $(document).on('change','#Tumu2', function () {
        if ($(this).is(':checked')) {
            $('.Sec2').prop('checked', true);
        } else {
            $('.Sec2').prop('checked', false);
        }
    });

    $(document).on('change','.Sec2', function () {
        var tumu = $('#Tumu2');
        if (tumu.is(':checked') && !$(this).is(':checked')) {
            tumu.prop('checked', false);
        }
    });

    $(document).on('click', '.toggle-btn', function () {
        var body = $('body'), bodyposition = body.css('position');

        if (bodyposition != 'relative') {
            if (!body.hasClass('sidebar-collapsed')) {
                body.addClass('sidebar-collapsed');
                $('.side-navigation ul').attr('style', '');
            } else {
                body.removeClass('sidebar-collapsed');
                $('.side-navigation li.active ul').css({display: 'block'});
            }
            setTimeout(function () {
                tableScrollFunc();
            }, 500);
        } else {
            if (body.hasClass('sidebar-open'))
                body.removeClass('sidebar-open');
            else
                body.addClass('sidebar-open');
            /*
            adjustMainContentHeight();
            */
        }
    });

    $(document).on('click', '.panel .tools .t-collapse', function () {
        var el = jQuery(this).parents('.panel').children('.panel-body');
        if (jQuery(this).hasClass('fa-chevron-down')) {
            jQuery(this).removeClass('fa-chevron-down').addClass('fa-chevron-up');
            el.slideUp(200);
        } else {
            jQuery(this).removeClass('fa-chevron-up').addClass('fa-chevron-down');
            el.slideDown(200);
        }
    });

    $(document).on('click', '.panel .tools .t-close', function () {
        $(this).parents('.panel').parent().remove();
    });

    $('body').on('mouseup', function (e) {
        $('.mtooltip.active').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).removeClass('active');
                $(this).popover('hide');
            }
        });
    });

    $('.pagination-wrapper input[name="Page"]').on('keyup', function (e) {
        e.preventDefault();
        if (e.keyCode == 13) {
            $(this).closest('.go').find('button').trigger('click');
        }
    });

    $('.pagination-wrapper button').click(function (e) {
        e.preventDefault();
        var sayfa = $(this).closest('.pagination-wrapper').find('input[name="Page"]').val(),
            sayfalama = $(this).closest('.pagination-wrapper').find('.pagination');
        if ($.isNumeric(sayfa)) {
            sayfa = parseInt(sayfa)
            if (sayfa > 0 && sayfa <= sayfalama.attr('data-last-page')) {
                location.href = sayfalama.find('a:eq(0)').attr('href').split('Sayfa=')[0] + 'Sayfa=' + sayfa
            } else {
                alert('Lütfen geçerli bir sayfa numarası (1 - ' + sayfalama.attr('data-last-page') + ') giriniz.');
            }
        } else {
            alert('Lütfen geçerli bir sayfa numarası (1 - ' + sayfalama.attr('data-last-page') + ') giriniz.');
        }
    });

    $('.Para').each(function () {
        var deger = this.value;
        deger = jQuery.number(deger, 2, ',', '.');
        $(this).val(deger);
    });

    $('.cost-Para').each(function () {
        var deger = this.value;
        deger = jQuery.number(deger, 2, ',', '.');
        $(this).val(deger);
    });

    var EskiFiyat = '-1';
    $(document).on('focus', '.Para', function () {
        EskiFiyat = this.value;
        this.value = '';
    });

    $(document).on('focus', '.cost-Para', function () {
        EskiFiyat = this.value;
        this.value = '';
    });

    $(document).on('blur', '.Para', function () {
        if (EskiFiyat != '-1' && this.value == '') {
            this.value = EskiFiyat;
        } else {
            var deger = this.value;
            deger = deger.replace('\.', '');
            deger = $.number(deger, 2, ',', '.');
            $(this).val(deger);
        }
    });

    $(document).on('blur', '.cost-Para', function () {
        if (EskiFiyat != '-1' && this.value == '') {
            this.value = EskiFiyat;
        } else {
            var deger = this.value;
            deger = deger.replace('\.', '');
            deger = $.number(deger, 2, ',', '.');
            $(this).val(deger);
        }
    });

    $('.Oran').each(function () {
        var deger = this.value;
        deger = jQuery.number(deger, 2, ',', '.');
        $(this).val(deger);
    });

    var EskiOran = '-1';
    $(document).on('focus', '.Oran', function () {
        EskiOran = this.value;
        this.value = '';
    });

    $(document).on('blur', '.Oran', function () {
        if (EskiOran != '-1' && this.value == '') {
            this.value = EskiOran;
        } else {
            var deger = this.value;
            deger = deger.replace('\.', '');
            deger = $.number(deger, 2, ',', '.');
            if ($(this).attr('data-min') && $.isNumeric($(this).attr('data-min')) && parseFloat(deger) < parseFloat($(this).attr('data-min'))) {
                deger = $.number($(this).attr('data-min'), 2, ',', '.');
            }
            if ($(this).attr('data-max') && $.isNumeric($(this).attr('data-max')) && parseFloat(deger) > parseFloat($(this).attr('data-max'))) {
                deger = $.number($(this).attr('data-max'), 2, ',', '.');
            }
            $(this).val(deger);
        }
    });

    $('.Stok').each(function () {
        var deger = this.value;
        deger = $.number(deger, 0, ',', '.');
        $(this).val(deger);
    });

    var StokEskiFiyat = '-1';
    $(document).on('focus', '.Stok', function () {
        StokEskiFiyat = this.value;
        this.value = '';
    });

    $(document).on('blur', '.Stok', function (e) {
        if (StokEskiFiyat != '-1' && this.value == '') {
            this.value = StokEskiFiyat;
        } else {
            var deger = this.value;
            deger = deger.replace('\.', '');
            deger = $.number(deger, 0, ',', '.');
            $(this).val(deger);
        }
    });

    $(document).on('keypress', '.Para, .Stok, .Oran', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    });

    tableScrollFunc();
});

$(window).resize(function () {
    if ($('body').css('position') == 'relative') {
        $('body').removeClass('sidebar-collapsed');
    } else {
        $('body').css({left: '', marginRight: ''});
    }
    tableScrollFunc();
});

$(window).scroll(function () {
    var sctop = $(this).scrollTop();
    $('.table-fixed-head').each(function () {
        if (sctop > ($(this).offset().top - 10) && sctop < (parseInt($(this).offset().top + $(this).outerHeight()) - 92)) {
            $(this).find('.scroll-clone').addClass('fixed');
        } else {
            $(this).find('.scroll-clone').removeClass('fixed');
        }
    });
});

function visibleSubMenuClose() {
    $('.nav-parent.nav-active').each(function () {
        var t = $(this);
        t.find('>ul').slideUp(300, function () {
            t.removeClass('nav-active');
            /*
            adjustMainContentHeight();
            */
        });
    });
}

/*
function adjustMainContentHeight(){
    var docHeight = $('.sidebar-left').outerHeight() + 80;
    if(docHeight < $(window).height()){ docHeight = $(window).height(); }
    $('.body-content').css('min-height', docHeight +'px');
}
*/
function tableScrollFunc() {
    $('.table-responsive').each(function () {
        var el = $(this),
            eltable = $(this).find('table'),
            elthead = $(this).find('thead'),
            eltbody = $(this).find('tbody');

        if (el.width() < eltbody.width() && $(window).width() > 991) {
            if (el.find('.scroll-clone').length) {
                el.find('.scroll-clone').remove();
            }
            var elsc = $('<div class="scroll-clone"></div>').prependTo(el),
                elhd = $('<div></div>').appendTo(elsc);

            elthead.find('>tr th').each(function (i) {
                $('<div>' + $(this).text() + '</div>').appendTo(elhd).width($(this).width());
            });

            el.addClass('table-fixed-head');
            elsc.width(el.width());
            elhd.width(eltbody.width());
            $(window).scroll();

            elsc.scroll(function () {
                if ($(this).next('.table').length) {
                    $(this).next('.table').scrollLeft($(this).scrollLeft());
                }
                if ($(this).next('.dataTables_wrapper').find('.table').length) {
                    $(this).next('.dataTables_wrapper').find('.table').scrollLeft($(this).scrollLeft());
                }
            });
            eltable.scroll(function () {
                if ($(this).prev('.scroll-clone').length) {
                    $(this).prev('.scroll-clone').scrollLeft($(this).scrollLeft());
                }
                if ($(this).closest('.dataTables_wrapper').prev('.scroll-clone').length) {
                    $(this).closest('.dataTables_wrapper').prev('.scroll-clone').scrollLeft($(this).scrollLeft());
                }
            });
        } else {
            if (el.hasClass('table-fixed-head')) {
                el.removeClass('table-fixed-head').find('.scroll-clone').remove();
            }
        }
    });
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}
